export const achievementData = {
    bio : "",
    achievements : [
        {
            id : 1,
            title : 'Code Yourself! An Introduction to Programming',
            details : 'An Introduction to Programming from The University of Edinburgh Uruguay',
            date : 'May 13, 2020',
            field : 'Programming',
            image : 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-university-assets.s3.amazonaws.com/a9/e4018cf6f3036dcc6762b8058a92f1/square.png?auto=format%2Ccompress&dpr=1&w=80&h=80'
        },
        {
            id : 2,
            title : 'An Introduction of python',
            details : 'The Codex on Udemy.',
            date : 'Feb 23, 2018',
            field : 'Programming',
            image : 'https://www.udemy.com/staticx/udemy/images/v7/logo-udemy.svg'
        },
        {
            id : 3,
            title : 'AWS',
            details : 'An Introduction to AWS from Masai School',
            date : 'Dec 23, 2021',
            field : 'Programming',
            image : 'https://unitus.vc/wp-content/uploads/2020/08/Masai-School-PF-1.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/